import { render, staticRenderFns } from "./RedirectByProject.vue?vue&type=template&id=631b32ef"
import script from "./RedirectByProject.vue?vue&type=script&lang=js"
export * from "./RedirectByProject.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports